import React from "react";
import classnames from "classnames";

interface Props {
	className?: string;
	children: React.ReactNode;
}

function ListGroupItem({ className, children }: Props) {
	return (
		<li
			className={classnames(
				"list-group-item list-group-card",
				className
			)}>
			{children}
		</li>
	);
}

export default ListGroupItem;
